import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

export const PostHogPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip tracking for admin routes
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Skip if PostHog not initialized
    if (!posthog.__loaded) {
      return;
    }

    // Capture page view
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  return null;
};
